import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import type { FragmentArray } from 'ember-data-model-fragments/array/fragment';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import type TillUser from 'linced-app/models/finance/daily-summary/till-user';

// Proto: finance.DailySummaryTill.
export default class Till extends Fragment {
  declare [Type]: 'finance/daily-summary/till';

  @attr('string', { defaultValue: '' })
  declare tillCode: string;

  @fragmentArray('finance/daily-summary/till-user')
  declare users: FragmentArray<TillUser>;
}
